import { useContext } from "react";

import { PerformanceChartContext } from "@contexts/PerformanceChartContext";

export const usePerformanceChart = () => {
  return useContext(PerformanceChartContext);
};
